const images = JSON.parse(process.env.nextImagesConfig || '{}');

const isImageOptimizable = (url?: string) => {
  if (!url) return false;

  let optimizable = false;

  try {
    optimizable = !!images?.domains?.some(
      (domain: string) => domain === new URL(url).hostname,
    );
  } catch (error) { /** Do nothing */ }

  return optimizable;
};
export default isImageOptimizable;
